import { render, staticRenderFns } from "./AttendeesListItem.vue?vue&type=template&id=68af1309&scoped=true"
import script from "./AttendeesListItem.vue?vue&type=script&lang=js"
export * from "./AttendeesListItem.vue?vue&type=script&lang=js"
import style0 from "./AttendeesListItem.vue?vue&type=style&index=0&id=68af1309&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68af1309",
  null
  
)

export default component.exports